<div
  class="tw-px-4 tw-py-1 {{
    props?.container
  }} tw-rounded tw-justify-center tw-items-center tw-gap-2 tw-inline-flex"
>
  <div class="{{ props?.badge }}  {{ small ? 'tw-text-xs' : 'tw-text-sm' }}">
    <ng-content></ng-content>
  </div>
</div>
